import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments/StoreFragment'

export const CREATE_STORE = gql`
  mutation CreateStore($data: CreateStoreInput!) {
    createStore(data: $data) {
      ...Store
    }
  }
  ${STORE_FRAGMENT}
`
